




































































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";

@Component
export default class Taxonomy extends Vue {
  private items = [];
  private columns = [
    { field: "node_id", label: "ID" },
    { field: "name", label: "Name" },
  ];
  private expanded: string[] = [];
  private form: any = {};
  private formAdd = false;
  private modal = false;

  async load() {
    this.items = (
      await axios.get<[]>("/cat/v2/tree", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
  }

  async mounted() {
    this.load();
    //this.items = (await axios.get<[]>("/cat/v2/list")).data;
  }

  toggle(nodeId: string) {
    var index = this.expanded.indexOf(nodeId);
    if (index !== -1) this.expanded.splice(index, 1);
    else this.expanded.push(nodeId);
  }

  onClick(node: any) {
    console.log(node, node.node_id);
  }

  isExpanded(nodeId: string) {
    return this.expanded.indexOf(nodeId) !== -1;
  }

  async edit(node: any) {
    var res = await axios.get<[]>(`/cat/v2/${node.shortened_area_name}/lang`, {
      headers: {
        Authorization: "Bearer " + localStorage.token,
      },
    });
    this.form = res.data;
    this.form.parent_id = node.parent_id;
    this.formAdd = false;
    this.modal = true;
  }

  async add(node: any) {
    if (node)
      this.form = {
        parent_id: node.node_id,
        name: node.name,
        node_id: node.node_id + ".",
      };
    else this.form = {};
    // if (node) this.form.parent_id = node.parent_id;
    this.formAdd = true;
    this.modal = true;
  }

  async submitForm() {
    await axios.post<[]>("/cat/v2/edit", this.form, {
      headers: {
        Authorization: "Bearer " + localStorage.token,
      },
    });
    this.modal = false;
    this.load();
  }
}
